import React from 'react';
import { PositionOverview } from './PositionOverview';
import { HedgeChart } from './HedgeChart';
import { HedgeDetails } from './HedgeDetails';
import { ExecuteHedge } from './ExecuteHedge';
import { usePositionSync } from '../hooks/usePositionSync';
import { useHedgeStrategy } from '../hooks/useHedgeStrategy';

export const AutoHedgeDashboard = () => {
  const { positions, loading } = usePositionSync();
  const { hedgeStrategy, isCalculating } = useHedgeStrategy(positions[0]);

  const handleExecuteHedge = async (strategy) => {
    try {
      console.log('🛡️ Executing hedge strategy:', strategy);
      return { success: true };
    } catch (error) {
      console.error('Hedge execution failed:', error);
      throw error;
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin w-8 h-8 border-2 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <div className="text-gray-400">Loading positions...</div>
      </div>
    );
  }

  if (!positions || positions.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">📊</div>
        <div className="text-white text-xl font-bold mb-2">No Positions Found</div>
        <div className="text-gray-400">Open a perpetual position to enable auto hedging</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-white text-xl font-bold mb-2">
          Protect Your Position
        </h3>
        <p className="text-gray-400">
          Automated hedging for your perpetual futures
        </p>
      </div>

      <PositionOverview position={positions[0]} />
      <HedgeChart perpPosition={positions[0]} optionHedge={hedgeStrategy} />

      {hedgeStrategy && (
        <>
          <HedgeDetails hedgeStrategy={hedgeStrategy} perpPosition={positions[0]} />
          <ExecuteHedge hedgeStrategy={hedgeStrategy} onExecute={handleExecuteHedge} />
        </>
      )}

      {isCalculating && (
        <div className="bg-atticus-navy-800 rounded-xl p-6 text-center">
          <div className="animate-spin w-6 h-6 border-2 border-purple-500 border-t-transparent rounded-full mx-auto mb-3"></div>
          <div className="text-gray-400">Calculating optimal hedge strategy...</div>
        </div>
      )}
    </div>
  );
};
